import { FC } from 'react';
import {
  ChipField,
  EmailField,
  ReferenceArrayField,
  Show,
  ShowProps,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
} from 'react-admin';

const UserShow: FC<ShowProps> = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="name" />
      <EmailField source="email" />
      <ReferenceArrayField reference="roles" source="role_ids" emptyText="-">
        <SingleFieldList linkType={false}>
          <ChipField source="short_description" />
        </SingleFieldList>
      </ReferenceArrayField>
    </SimpleShowLayout>
  </Show>
);

export default UserShow;
